import type { ReactNode } from "react";
import { cx } from "./utils";

export interface EmptyStateProps {
  /** Short headline, e.g. "今天没有任务". */
  title: ReactNode;
  /** Explanatory line under the title. */
  description?: ReactNode;
  /** Decorative illustration or `<Icon/>` above the title. */
  icon?: ReactNode;
  /** Primary action(s). */
  action?: ReactNode;
  /** @default "md" */
  size?: "sm" | "md";
  className?: string;
}

/** Design-system empty state (`gz-empty`) for empty lists and queues. */
export function EmptyState({
  title,
  description,
  icon,
  action,
  size = "md",
  className,
}: EmptyStateProps) {
  return (
    <div className={cx("gz-empty", "xz-empty", `xz-empty--${size}`, className)}>
      {icon != null && (
        <div className="xz-empty__icon" aria-hidden="true">
          {icon}
        </div>
      )}
      <p className="xz-empty__title">{title}</p>
      {description != null && <p className="xz-empty__desc gz-muted">{description}</p>}
      {action != null && <div className="xz-empty__action">{action}</div>}
    </div>
  );
}
